export * from '../../domain/entities/auth-content/AuthContentVM.type';
export { DEFAULT_AUTH_CONTENT } from '../../domain/store/auth-content/AuthContentStore';
